export const BooleanUtils = {
  ConvertBooleanToYesNo(value: boolean): string {
    return value ? 'Yes' : 'No';
  }
};
